import ExitIcon from './ExitIcon';

export default ExitIcon;
